import { AdapterBase } from '@navix/utils/adapter'
import { Order } from '../../domain/orders/order.model'

export class ToOrderAdapter extends AdapterBase<unknown, Order | Order[]> {}
